import { defineStore } from 'pinia';
import { FiltersApi } from '@/api/storageTracking/FiltersApi.ts';
import { ref } from 'vue';
import { ISearchableContent } from '@/interfaces/storageTracking/ISearchableContent.ts';
import { IFormattedSearchOptions } from '@/interfaces/powerMarkets/ISearchDefinition.ts';
import { useDeltaUserSettingsStore } from '@/stores/deltaGpt/deltaGptUserSettingsStore.ts';
import { IRecentSearch } from '@/interfaces/deltaGpt/IRecentSearch.ts';

export const useSearchStore = defineStore('searchStore', () => {
    const storetrackSearchableContent = ref<ISearchableContent | null>(null);
    const recentSearches = ref<Array<IRecentSearch>>([]);
    const pinnedSearches = ref<Array<IRecentSearch>>([]);
    const deltaSettingsStore = useDeltaUserSettingsStore();

    function addRecentSearch (search: IFormattedSearchOptions, tab: string, useCountryIcon: boolean): void {
        if (recentSearches.value.some(item => item.option.id === search.id && item.tab === tab)) {
            recentSearches.value = recentSearches.value.filter(item => !(item.option.id === search.id && item.tab === tab));
        }

        recentSearches.value.unshift({ option: search, tab, useCountryIcon });
        if (recentSearches.value.length > 10) {
            recentSearches.value.pop();
        }

        deltaSettingsStore.updateUserSettings({
            recentSearches: recentSearches.value,
        });
    }

    function addPinnedSearch (search: IFormattedSearchOptions, tab: string, useCountryIcon: boolean): void {
        if (pinnedSearches.value.some(item => item.option.id === search.id && item.tab === tab)) {
            pinnedSearches.value = pinnedSearches.value.filter(item => !(item.option.id === search.id && item.tab === tab));
        }

        pinnedSearches.value.unshift({ option: search, tab, useCountryIcon });

        deltaSettingsStore.updateUserSettings({
            pinnedSearches: pinnedSearches.value,
            recentSearches: recentSearches.value,
        });
    }

    function removePinnedSearch (search: IFormattedSearchOptions, tab: string): void {
        pinnedSearches.value = pinnedSearches.value.filter(
            item => !(item.option.id === search.id && item.tab === tab),
        );

        deltaSettingsStore.updateUserSettings({
            pinnedSearches: pinnedSearches.value,
        });
    }

    async function getSearchStoretrackContent (): Promise<void> {
        storetrackSearchableContent.value = await FiltersApi.getSearchableContent();
    }

    function getDeltaUserSettings (): void {
        recentSearches.value = deltaSettingsStore.userSettings.recentSearches;
        pinnedSearches.value = deltaSettingsStore.userSettings.pinnedSearches;
    }

    async function initialiseSearchStore (): Promise<void> {
        getDeltaUserSettings();
        await getSearchStoretrackContent();
    }

    initialiseSearchStore();

    return {
        storetrackSearchableContent,
        recentSearches,
        pinnedSearches,
        addRecentSearch,
        addPinnedSearch,
        removePinnedSearch,
    };
});
